// models
import { AddInviteKeys, Organization } from '@karehero/models';

import { InviteMembersForm } from '@/components/organisms';

const isValid = (value: string) => {
  return /\S+@\S+\.\S+/.test(value || '');
};

/**
 * InviteMembersByEmailForm is a component that allows members to be invited by email input field or
 * a CSV file of emails.
 */
export const InviteMembersByEmailForm = ({
  organization,
  onSubmit,
}: InviteMembersByEmailFormProps) => {
  // does this need memo?
  return (
    <InviteMembersForm
      organization={organization}
      onSubmit={onSubmit}
      isValid={isValid}
      inputType='email'
      inviteKeyName='email'
    />
  );
};

interface InviteMembersByEmailFormProps {
  organization?: Organization;
  onSubmit: (req: AddInviteKeys) => void;
}

InviteMembersByEmailForm.displayName = 'InviteMembersByEmailForm';

export default InviteMembersByEmailForm;
